import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "defar_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-0 inset-x-0 z-[2000] bg-brand-blue text-white shadow-2xl animate-fade-in-up"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie size={26} className="text-brand-accent shrink-0" />
        <p className="text-sm text-blue-100 flex-1 leading-relaxed">
          Ce site utilise uniquement des cookies essentiels à son bon fonctionnement. Aucune
          donnée n'est utilisée à des fins publicitaires. En poursuivant votre navigation, vous
          acceptez notre{" "}
          <Link to="/mentions-legales" className="underline font-semibold text-white hover:text-brand-accent">
            politique de confidentialité
          </Link>
          .
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            data-testid="cookie-accept-btn"
            onClick={accept}
            className="bg-brand-green hover:bg-brand-greenhover transition-colors px-6 py-2.5 text-sm font-semibold"
          >
            J'accepte
          </button>
          <button
            data-testid="cookie-close-btn"
            onClick={accept}
            aria-label="Fermer"
            className="text-blue-200 hover:text-white p-1"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};
